import React from "react";
import { ManageEventModalProps } from "src/interfaces/event-props.interface";
import Modal from "src/components/common/Modal";
import EventForm from "./EventForm";

const ManageEventModal = React.memo(({
  eventToEdit,
  isEventModalOpen,
  handleCloseEventModal,
  onEventsMutated,
}: ManageEventModalProps) => {
  
  const eventModalTitle = eventToEdit
    ? "Edit Event"
    : "Add Event";

  return (
    <Modal
      isOpen={isEventModalOpen}
      onClose={handleCloseEventModal}
      title={eventModalTitle}
      width="1106px"
    >
      <EventForm
        eventToEdit={eventToEdit}
        handleCloseEventModal={handleCloseEventModal}
        onEventsMutated={onEventsMutated}
      />
    </Modal>
  );
});

export default ManageEventModal;

